import PostsEvents from "./PostsEvents";
import Posts from "./components/Posts/Posts";
import Events from "./components/Events/Events";

export { Posts, Events };
export default PostsEvents;
